/**
 * 利用できる画面が 1 つも無いユーザー向けの表示 (権限管理 SBI-6)。
 *
 * 所属グループが無い / どのグループにも ControlPanel の画面が含まれない場合に出す。
 */
export function NoPermissionScreen(): React.JSX.Element {
  return (
    <div className="empty-state" role="status" data-testid="no-permission">
      権限がありません。管理者に連絡してください
    </div>
  );
}

interface PermissionErrorScreenProps {
  message: string | null;
  onRetry: () => void;
}

/** 権限情報を取得できなかった場合の表示。安全側 (何も出さない) に倒したうえで再試行を案内する。 */
export function PermissionErrorScreen({
  message,
  onRetry,
}: PermissionErrorScreenProps): React.JSX.Element {
  return (
    <div className="empty-state" data-testid="permission-error">
      <p className="error-message" role="alert">
        権限情報を取得できませんでした{message ? `: ${message}` : ''}
      </p>
      <button type="button" onClick={onRetry} data-testid="permission-retry">
        再試行
      </button>
    </div>
  );
}
